<template>
  <!-- Bez vlastitog v-containera: komponenta se uklapa u red alatki koji je
       slaze, pa nema praznog prostora oko gumba. -->
  <div class="digitalna-arhiva" :class="{ otvorena: showDigital }">
    <v-btn
      v-if="!showDigital"
      small
      outlined
      color="primary"
      @click="hideDigital">
      {{lang.DigitalAr}} {{haveDescription}}
    </v-btn>
    <div v-if="showDigital" class="sadrzaj">
      <v-card outlined class="pa-3">
        <div class="d-flex align-center flex-wrap" style="gap:8px">
          <v-btn small outlined color="primary" @click="hideDigital">
            <v-icon small>mdi-chevron-up</v-icon>{{lang.DigitalAr}}
          </v-btn>
          <div style="max-width:260px;flex:1 1 200px">
            <v-text-field
              outlined
              dense
              hide-details
              :label="lang.ShortDesc"
              v-model="desc"
            ></v-text-field>
          </div>
          <div style="max-width:320px;flex:1 1 240px">
            <v-file-input outlined dense hide-details v-model="somefile" single label="File input"></v-file-input>
          </div>
          <v-btn small color="primary" @click="onSubmit">Upload</v-btn>
          <v-progress-circular v-if="this.saving" indeterminate color="green" size="20"></v-progress-circular>
        </div>

        <v-data-table
          class="mt-3"
          dense
          :headers="headers"
          :items="items"
          item-key="newId"
          @click:row="showPdf"
          :mobile-breakpoint="0"
          hide-default-footer
        >
          <template v-slot:[`item.LastUpdate`]="{ item }">
              <span>{{ localDate(item.LastUpdate) }}</span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon
              small
              @click="deleteItem(item)"
            >
              mdi-trash-can
            </v-icon>
          </template>
        </v-data-table>
      </v-card>

      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        bottom
        :color="color"
        >
        {{ text }}
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import DigitalDocService from '@/services/DigitalDocService'
import MainLedgerService from '@/services/MainLedgerService'
import ConverterService from '@/services/ConverterService'
import Api from '@/services/Api'
import {defDigitalDoc, defNewDigitalDoc } from './DigitalDocHelper'
import langEn from './digitaldocDescEn'
import langHr from './digitaldocDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dayjs from 'dayjs'
 
export default {
  name: 'digitaldocshortlist',
  data () {
    return {
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      somefile: null,
      errors: null,
      data: null,
      attachment : { name : null,file: null },
      documentName: '',
      documentNameLoc: '',
      docside: 0,
      msg: '',
      items: [],
      tmp: '',
      search: '',
      headers: [ ],
      mainQuery: {},
      lang: {},
      langC: {},
      saving: false,
      searchName: "",
      havealert: false,
      havemssgalert: '',
      query: {},
      desc: '',
      haveItems: 0,
      showDigital: false,
      haveDescription: '',
      doDelete: false,
      doConvert: false
    }
  },
  async beforemounted() {
    await this.defaultInit()
   
  },
  async mounted () {
    this.$store.dispatch('setDocumentActivPdfs', [])
    if (this.$store.state.language === "EN") {
      this.lang = langEn
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = langHr
      this.langC = commHr;
    }
    this.documentName = this.$store.state.documentActiv
    this.documentNameLoc = this.$store.state.documentActivLoc

    this.headers.push(
      {
        text: this.lang.Desc, align: 'left', sortable: true, value: 'Description', width: '130px'
      },
      { text: this.lang.Name, align: 'left', sortable: true, value: 'originalname', width: '100px' },
      { text: this.lang.Saved , align: 'left', sortable: true, value: 'LastUpdate', width: '100px' },
      { text: this.lang.Actions, value: 'action', sortable: false, width: '10px' },
    )
    this.defaultInit()
  },
  methods: {
    localDate(dateToFormat) {
      return dayjs(dateToFormat).format('DD.MM.YYYY HH:mm:ss')
    },
    hideDigital () {
      this.showDigital = !this.showDigital
    },  
    async defaultInit() {
      const emptyObj = {}
      this.query = {...emptyObj}
      this.query.CompanyId = this.$store.state.companyid
      this.query.BusinessYear = this.$store.state.businessYear
      this.query.documentSide = this.$store.state.documentSide
      this.query.productiontypes = this.$store.state.productiontype
      this.query.documentName = this.$store.state.documentActivHead.documentName
      this.query.documentNameLoc = this.$store.state.documentActivLoc
      this.query.documentIdGeneral = this.$store.state.documentActivHead.documentIdGeneral

      this.saving = true
      await DigitalDocService.index(this.query)
      .then(res => {
        console.log('res', res)
        this.items = res.data.digitaldocs ? res.data.digitaldocs : []
        this.$store.dispatch('setDocumentActivPdfs', this.items)
        this.haveItems = this.items.length
        this.haveDescription = this.haveItems > 0 ? '(' + this.lang.Docs + ': ' + this.haveItems.toString() + ' )' : '(' + this.lang.Empty + ')'
      })
      .catch(err => {
        this.havealert = !this.havealert
        this.havemssgalert = 'Error' + err
      })
      this.saving = false
      
    },
    async initAgain () {
      this.defaultInit()
    },
    onSubmit() {
      const newId = this.getRndInteger(100000, 900000)
      let fd = new FormData()
      fd.append('companyId', this.$store.state.companyid)
      fd.append('newId', newId)
      fd.append('originalName', this.somefile.name)
      fd.append('typeDoc', this.$store.state.documentActivHead.documentName)
      fd.append('myFile', this.somefile, this.somefile.name)
      console.log('fd', fd)
      Api().post('bookin/invoice', fd).then(response => {
          this.data = response.data
            if (this.data) {
              const newD = defDigitalDoc()
              const newDD = {...newD, ...defNewDigitalDoc()}
              newDD.originalname = this.data.originalname ? this.data.originalname : ''
              newDD.filename = this.data.filename ? this.data.filename : ''
              newDD.destination = this.data.destination ? this.data.destination : ''
              newDD.path = this.data.path ? this.data.path : ''
              newDD.typeDoc = this.$store.state.documentActivHead.documentName ? this.$store.state.documentActivHead.documentName : ''
              newDD.documentIdGeneral = this.query.documentIdGeneral ? this.query.documentIdGeneral : ''
              newDD.documentName = this.query.documentName
              newDD.documentSide = this.query.documentSide
              newDD.documentId = this.$store.state.documentActivHead.documentId ? parseInt(this.$store.state.documentActivHead.documentId) : ''
              newDD.Description = this.desc ? this.desc : ''
              newDD.newId = newId
              this.updateDB(newDD)
              this.somefile = null
              this.desc = ''
          }
      }).catch(error => {
          this.text = 'Error ' + error
          this.color = 'red'
          this.snackbar = true
          if (error.response.status === 422) {
              this.errors = error.response.data.errors || {};
          }
      });
    },
    async updateDB(newDD) {
      try {
        await DigitalDocService.post(newDD).then(res => {
          this.text = this.lang.SavedDoc + res.data.message
          this.color = 'green'
          this.snackbar = true
          this.defaultInit()
        }).catch(error => {
          this.text = 'Error ' + error
          this.color = 'red'
          this.snackbar = true
        })         
      } catch (error) {
        this.text = 'Error ' + error
        this.color = 'red'
        this.snackbar = true
      }
    },
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },
    async showPdf(params) {
      if (this.doDelete) {
        return
      }
      if (this.doConvert) {
        return
      }
      if (params.path) {
        const showFile ={
          showFile: params.path
        }
        await MainLedgerService.showPdf(showFile)
        .then(res => {
          const data = res.data
          var byteCharacters = atob(data);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], { type: "application/pdf" });

          //FileSaver.saveAs(blob, "invoice.pdf")

          // // const zoveSe = this.mainledger.MLFree2 ? this.mainledger.MLFree2 : 'Book'
          //const header = res.headers
          //const fileType = header['content-type']
          //const file = new Blob([data], {type: fileType})
          // eslint-disable-next-line
          //console.log(' have file ', file)
          const fileurl = window.URL.createObjectURL(blob)
          window.open(fileurl)
          //FileSaver.saveAs(file, 'invoice.pdf');
        }).catch(error => {
          this.text = 'Error ' + error
          this.color = 'red'
          this.snackbar = true
        })
      } else {
        alert(this.lang.CannotFind)
      }
    },
    async deleteItem (item) {
      try {
        this.doDelete = true
        const warningMessage = item.originalname
        if (confirm(this.langC.AreYouShureToDelete + ' ' + warningMessage + '!')) {
          const updateItem = {...item}
          updateItem.Deleted = true
          await DigitalDocService.put(updateItem)
          await this.defaultInit()
        }
        this.doDelete = false
      } catch(err) {
        this.error = err
      }
    },
    async convertItem (item) {
      try {
        this.doConvert = true
        console.log('probam konvertirati ', item )
        const res = await ConverterService.convertPdfToBase64(item)
        console.log('res', res)
        const base64 = res && res.data && res.data.base64String ? res.data.base64String : null
        console.log('Imam konvertirani pdf u ', base64.substring(0, 100), base64.length);
        const dataUri = `data:application/pdf;base64,${base64}`;
        this.doConvert = false
      } catch(err) {
        this.error = err
      }
    },
  },
  computed: {

  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.digitalna-arhiva .sadrzaj { width: 100%; }
/* Kad je otvorena, zauzme cijeli red i spusti se ispod gumba s alatkama,
   umjesto da ih razbija. */
.digitalna-arhiva.otvorena { width: 100%; order: 10; }


</style>
